let activeStopHandler = null;

export const stopActiveMessageSpeech = () => {
	if (activeStopHandler) {
		activeStopHandler();
		activeStopHandler = null;
	}
};

export const registerActiveMessageSpeech = (stopHandler) => {
	stopActiveMessageSpeech();
	activeStopHandler = stopHandler;
};

export const clearActiveMessageSpeech = (stopHandler) => {
	if (activeStopHandler === stopHandler) {
		activeStopHandler = null;
	}
};
